import api from '@/api';
import * as types from '@/store/types';

const state = {
    AdvBillingState: [],
    AdvBeOrderState: [],
    AdvBillingContext: [],
    SiteId: [],
    ClickParamNames: [],
    EventParamNames: [],
    upyieldParamNames:  [],
};


const getters = {
    tagsAdvBillingState: state => state.AdvBillingState,
    tagsAdvBeOrderState: state => state.AdvBeOrderState,
    tagsAdvBillingContext: state => state.AdvBillingContext,
    tagsClickParamNames: state => state.ClickParamNames,
    tagsEventParamNames: state => state.EventParamNames,
    tagsUpyieldParamNames: state => state.upyieldParamNames,
};


const actions = {
    getAdvBillingState ({ commit }) {
        return api.tags.tagsAdvBillingState().then((response) => {
            commit(types.RECEIVE_TAGS_BILLINGSTATE, response.data);
        });
    },
    getAdvBeOrderState ({ commit }) {
        return api.tags.tagsAdvBeOrderState().then((response) => {
            commit(types.RECEIVE_TAGS_ORDERSTATE, response.data);
        });
    },
    getAdvBillingContext ({ commit }) {
        return api.tags.tagsAdvBillingContext().then((response) => {
            commit(types.RECEIVE_TAGS_BILLINGCONTEXT, response.data);
        });
    },
    getClickParamNames ({ commit }) {
        return api.tags.tagsTriggerParamClick().then((response) => {
            commit(types.RECEIVE_TAGS_CLICK_PARAM_NAMES, response.data);
        });
    },
    getEventParamNames ({ commit }) {
        return api.tags.tagsTriggerParamEvent().then((response) => {
            commit(types.RECEIVE_TAGS_EVENT_PARAM_NAMES, response.data);
        });
    },
    getTagsTriggerParamYieldr ({ commit }) {
        return api.tags.tagsTriggerParamYieldr().then((response) => {
            commit(types.RECEIVE_TAGS_UPYIELD_PARAM_NAMES, response.data);
        });
    },
};


const mutations = {
    [types.RECEIVE_TAGS_BILLINGSTATE] (state, { data }) {
        state.AdvBillingState = data;
    },
    [types.RECEIVE_TAGS_ORDERSTATE] (state, { data }) {
        state.AdvBeOrderState = data;
    },
    [types.RECEIVE_TAGS_BILLINGCONTEXT] (state, { data }) {
        state.AdvBillingContext = data;
    },
    [types.RECEIVE_TAGS_CLICK_PARAM_NAMES] (state, { data }) {
        state.ClickParamNames = data;
    },
    [types.RECEIVE_TAGS_EVENT_PARAM_NAMES] (state, { data }) {
        state.EventParamNames = data;
    },
    [types.RECEIVE_TAGS_UPYIELD_PARAM_NAMES] (state, { data }) {
        state.upyieldParamNames = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
